
import styled from "styled-components";


const WrapContext = styled.span`
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-break: break-word;
  overflow: hidden;
  white-space: normal;
`;

export default WrapContext;
